import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Portfolio from "./pages/Portfolio";
import PortfolioDetail from "./pages/PortfolioDetail";
import AboutMe from "./pages/AboutMe";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import RetencaoAgenciasLanding from "./pages/RetencaoAgenciasLanding";
import BiVendasPerformanceLanding from "./pages/BiVendasPerformanceLanding";
import DashboardsTrafegoPagoLanding from "./pages/DashboardsTrafegoPagoLanding";
import ComparativosPrevisosLanding from "./pages/ComparativosPrevisosLanding";
import MonitoramentoMultiContasLanding from "./pages/MonitoramentoMultiContasLanding";
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function AppContent() {
  const location = useLocation();
  const showWhatsApp = location.pathname === '/';

  return (
    <>
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/gestao-de-retencao-para-agencias" element={<RetencaoAgenciasLanding />} />
          <Route path="/services/bi-vendas-e-performance" element={<BiVendasPerformanceLanding />} />
          <Route path="/services/dashboards-trafego-pago-customizados" element={<DashboardsTrafegoPagoLanding />} />
          <Route path="/services/comparativos-e-previsoes" element={<ComparativosPrevisosLanding />} />
          <Route path="/services/monitoramento-multi-contas-ads" element={<MonitoramentoMultiContasLanding />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
      {showWhatsApp && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider> 
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </HelmetProvider> 
  );
}

export default App;
